import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    other: 'other',
  },
  de: {
    other: 'andere',
  },
});
